/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5730dc237080a5bd9f1fa9be8c6544e85d707864";
